export { default } from './TabletView.container'
